<template>
    <scroll-to-me v-if="!noLazy" @trigger-animate="pictureEnabled = true"
                  :heightOffset="0">
        <picture v-show="pictureEnabled" ref="picture">
            <source v-if="imageWebpSource"
                    :srcset="imageWebpSource.permalink"
                    :type="`image/${imageWebpSource.extension}`"/>
            <source v-if="imageOriginalSource"
                    :srcset="imageOriginalSource.permalink"
                    :type="`image/${imageOriginalSource.extension}`"/>
            <img :class="{'bg-mode': bgMode, circle: circle}"
                 :style="{
            borderRadius: radius + 'px',
            width: width,
            height: height,
            margin: center,
            position: position
            }"
                 class="inner-img"
                 :src="image.permalink"
                 :title="image.title"
                 :alt="image.alt"/>
        </picture>
    </scroll-to-me>
    <picture v-else v-show="pictureEnabled" ref="picture">

        <source v-if="imageWebpSource"
                :srcset="imageWebpSource.permalink"
                :type="`image/${imageWebpSource.extension}`"/>

        <source v-if="imageOriginalSource"
                :srcset="imageOriginalSource.permalink"
                :type="`image/${imageOriginalSource.extension}`"/>

        <img :class="{'bg-mode': bgMode, circle: circle}"
             :style="{
            borderRadius: radius + 'px',
            width: width,
            height: height,
            margin: center,
            position: position
            }"
             class="inner-img"
             :src="image.permalink"
             :title="image.title"
             :alt="image.alt"/>
    </picture>
</template>

<script>
    export default {
        components: {
            ScrollToMe: () => import('./ScrollToMe')
        },
        props: {
            'image': {
                type: Object,
                required: true
            },
            'no-lazy': {
                type: Boolean,
                required: false,
                default: false
            },
            'bg-mode': {
                type: Boolean,
                required: false,
                default: false
            },
            'radius': {
                type: Number,
                required: false,
                default: 0
            },
            'circle': {
                type: Boolean,
                required: false,
                default: false
            },
            width: {
                type: String,
                required: false,
                default: ''
            },
            height: {
                type: String,
                required: false,
                default: ''
            },
            center: {
                type: String,
                required: false,
                default: ''
            },
            position: {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                pictureEnabled: false
            }
        },
        computed: {
            imageOriginalSource() {
                if (!this.pictureEnabled) {
                    return null
                }

                const parentWidth = this.$refs.picture.parentNode.getBoundingClientRect().width;
                let resource = null;

                for (let image of this.image.resources) {
                    if (image.width >= parentWidth && image.extension !== 'webp') {
                        resource = image;
                    }
                }
                return resource;
            },
            imageWebpSource() {
                if (!this.pictureEnabled) {
                    return null
                }

                const parentWidth = this.$refs.picture.parentNode.getBoundingClientRect().width;
                let resource = null;

                for (let image of this.image.resources) {
                    if (image.width >= parentWidth && image.extension === 'webp') {
                        resource = image;
                    }
                }
                return resource;
            },
        }
    };
</script>

<style scoped>
    img {
        width: 100%;
        object-fit: cover;
    }

    .bg-mode {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
    }

    .circle {
        border-radius: 50% !important;
    }
</style>